import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod';

import { BlogPosts } from '#features/blog/components/BlogPosts';
import { blogPostsInfiniteQueryOptions, blogTagsQueryOptions } from '#features/blog/model/blog';
import { blogListHead } from '#features/blog/utils/blogListHead';

const blogSearchSchema = z.object({
  tag: z.string().optional(),
});

export const Route = createFileRoute('/{-$locale}/_layout/blog/')({
  validateSearch: zodValidator(blogSearchSchema),
  loaderDeps: ({ search }) => ({ tag: search.tag }),
  loader: ({ context, deps }) =>
    Promise.allSettled([
      context.queryClient.ensureInfiniteQueryData(blogPostsInfiniteQueryOptions(deps.tag)),
      context.queryClient.ensureQueryData(blogTagsQueryOptions()),
    ]),
  head: ({ params }) => blogListHead(params.locale),
  component: BlogPosts,
});
